import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './Styles/theme/index';

import Home from './Pages/Home';
import Login from './Pages/Login';
import Cert from './Pages/Cert';
import FAQ from './Pages/FAQ';
import Share from './Pages/Share';
import ShareChemical from './Pages/ShareChemical';
import Oauth from './Pages/Oauth';
import TccsOauth from './Pages/TccsOauth';
import ShareManagement from './Pages/ShareManagement';
import RecipientShareManagement from './Pages/RecipientShareManagement';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Switch>
          <Route path="/cert/:id" component={Cert} />
          <Route path="/faq" component={FAQ} />
          <Route path="/share/:certName/:token/:date" component={Share} />
          <Route
            path="/sharechemical/:certName/:date"
            component={ShareChemical}
          />
          <Route path="/sigin/oauth2getid" component={Oauth} />
          <Route path="/signin/tccs-login" component={TccsOauth} />
          <Route path="/home" component={Home} />
          <Route path="/licenseshare" component={ShareManagement} />
          <Route path="/recipientshare" component={RecipientShareManagement} />
          <Route exact path="/" component={Login} />
        </Switch>
      </Router>
    </ChakraProvider>
  );
}

export default App;
